import { egresadosApiCall } from "../../../../axios/apiClient";

const controller = `idioma`;

export default {
    getIdiomasMe: async () => {
        let response = { success: true };
        const method = "me";
        try {
            const apiResponse = await egresadosApiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    createIdiomaMe: async (data) => {
        let response = { success: true };
        const method = "me";
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    editIdiomaMe: async (data) => {
        let response = { success: true };
        const method = "me";
        try {
            const apiResponse = await egresadosApiCall.put(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    deleteIdiomaMe: async (id) => {
        let response = { success: true };
        const method = `me/${id}`;
        try {
            const apiResponse = await egresadosApiCall.delete(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    getCatalogos: async () => {
        let response = { success: true };
        const method = "catalogos";
        try {
            const apiResponse = await egresadosApiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
}
